module.exports = __webpack_public_path__ + "static/img/笔.fbdcbf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/笔.png
// module id = 44Wz
// module chunks = 3